// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Agencies map
function getEventsMap($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesMap", webpackPrefetch: true */ './js/components/eventsMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des agences
    const $c1 = $('#map-events').length ? $('#map-events') : $('#map-detail')
    if ($c1.length) {
      $c1.waypoint(
        function () {
          getEventsMap($c1)
          this.destroy()
        },
        {
          offset: '100%',
        }
      )
    }
  })
})
